@if (isLoaded) {
  <div class="container-fluid" [@fadeInAnimation]>
    <div class="row">
      <div class="col-xl-1"></div>
      <div class="col-xl-10">
        <div class="card mb-3">
          <div class="card-header">
            <fa-icon [icon]="['fas', 'marker']" size="lg" class="me-2" [fixedWidth]="true"></fa-icon>{{ 'label.my-messages' | translate }}
          </div>
          <div class="card-body">
            @if (minaRequests.length) {
              <div class="mb-3">
                <div class="input-group">
                  <span class="input-group-text">
                      <fa-icon [icon]="['fas', 'filter']" [fixedWidth]="true"></fa-icon>
                    </span>
                  <input [(ngModel)]="filterText" type="text" name="filter" class="form-control rounded-end" placeholder="{{ 'label.filter' | translate}}" (ngModelChange)="applyFilter()">
                </div>
              </div>
              @if (minaRequests.length) {
                <div class="panel panel-default">
                  <div class="panel-heading">
                    <p class="h5">{{ 'label.info-requests' | translate }}</p>
                  </div>
                  <div class="panel-body">
                    @if (minaRequests.length) {
                      <div class="table-responsive">
                        <table class="table table-hover">
                          <thead>
                            <tr>
                              <th scope="col" [class.order-active]="order==='case'" (click)="setOrder('case')">
                                <div class="d-flex justify-content-between">
                                  {{ 'label.case' | translate }}
                                  <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                                </div>
                              </th>
                              <th scope="col" [class.order-active]="order==='date'" (click)="setOrder('date')">
                                <div class="d-flex justify-content-between">
                                  {{ 'label.sent' | translate }}
                                  <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                                </div>
                              </th>
                              <th scope="col" [class.order-active]="order==='requestFirm'" (click)="setOrder('requestFirm')">
                                <div class="d-flex justify-content-between">
                                  {{ 'label.sender' | translate }}
                                  <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                                </div>
                              </th>
                              <th scope="col" [class.order-active]="order==='about'" (click)="setOrder('about')">
                                <div class="d-flex justify-content-between">
                                  {{ 'label.subject' | translate }}
                                  <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                                </div>
                              </th>
                              <th scope="col" [class.order-active]="order==='status.namn'" (click)="setOrder('status.namn')">
                                <div class="d-flex justify-content-between">
                                  {{ 'label.status' | translate }}
                                  <fa-icon [icon]="['fas', reverse ? 'sort-amount-down' : 'sort-amount-up' ]" class="ms-2" [flip]="reverse||'vertical'"></fa-icon>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (t of minaRequests | orderBy: order:reverse:'case-insensitive' | filterBy: userFilter; track t) {
                              <tr [id]="t.id" class="link" [routerLink]="['/mina-meddelanden', t.id]">
                                <td data-name="Ärende">{{ t.case }}</td>
                                <td data-name="Skickad">{{ t.date | localizeddate:'shortDate' }} {{ t.date | localizeddate:'shortTime' }}</td>
                                <td data-name="Avsändare">{{ t.requestFirm }}</td>
                                <td data-name="Ämne">{{ t.about }}</td>
                                @if (t.answered) {
                                  <td data-name="Status">{{'label.request-answered' | translate }}</td>
                                }
                                @if (!t.answered) {
                                  <td data-name="Status"><b>{{'label.request-waiting-response' | translate }}</b></td>
                                }
                              </tr>
                            }
                          </tbody>
                          <tfoot>
                            <tr>
                              <th data-name="Antal" colspan="5">{{ (minaRequests | filterBy: userFilter).length | localizednumber }} {{ 'label.st' | translate }}</th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    }
                    @if (!(minaRequests | filterBy: userFilter).length) {
                      <p class="text-muted">{{ 'label.no-hits' | translate }}</p>
                    }
                  </div>
                </div>
              }
            }
            @if (!minaRequests.length) {
              <p class="text-muted">{{ 'label.no-messages' | translate }}</p>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}
